import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ResourceImageComponent
} from '../resource-image/resource-image.component';
import {
  ResourceVideoPlayerComponent
} from '../resource-video-player/resource-video-player.component';
import {
  ResourceLeftLayoutDirective
} from '../../directives/resource-left-layout.directive';
import {
  ResourceRightLayoutDirective
} from '../../directives/resource-right-layout.directive';
import { ResourceTextComponent } from '../resource-text/resource-text.component';
import {
  ResourceAccordionComponent
} from '../resource-accordion/resource-accordion.component';
import {
  ResourceGoogleSlidePreviewComponent
} from '../resource-google-slide-preview/resource-google-slide-preview.component';
import {
  ResourceMiddleLayoutDirective
} from '../../directives/resource-middle-layout.directive';
import { Store } from "@ngrx/store";
import { screenSize } from "../../../../shared/core/shared.selectors";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: 'app-resource-layout',
  templateUrl: './resource-layout.component.html',
  styleUrls: ['./resource-layout.component.css']
})
export class ResourceLayoutComponent implements OnInit {
  @Input() layouts: any;
  @ViewChild(ResourceLeftLayoutDirective, { static: true }) leftSection!: ResourceLeftLayoutDirective;
  @ViewChild(ResourceMiddleLayoutDirective, { static: true }) middleSection!: ResourceMiddleLayoutDirective;
  @ViewChild(ResourceRightLayoutDirective, { static: true }) rightSection!: ResourceRightLayoutDirective;
  contentTypeMap = {
    'video': ResourceVideoPlayerComponent,
    'image': ResourceImageComponent,
    'text': ResourceTextComponent,
    'accordion': ResourceAccordionComponent,
    'google-slide': ResourceGoogleSlidePreviewComponent
  }
  viewContainerRef = {
    0: 'left',
    1: 'middle',
    2: 'right'
  }
  screenSize: string = '';
  private readonly onDestroy: Subject<any> = new Subject<any>();


  constructor(
    private store: Store,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.store.select(screenSize).pipe(takeUntil(this.onDestroy))
      .subscribe(screenSize => {
        this.screenSize = screenSize;
      })
  }

  ngAfterViewInit() {
    this.loadDynamicContentComponents();
    this.cdRef.detectChanges();
  }

  loadDynamicContentComponents() {
    this.layouts.map((layout, index: number) => {
      this.createComponentBasedOnType(layout, index);
    })
  }

  getLayoutSectionWidth(layoutWidth) {
    if (layoutWidth) {
      return `w-full md:w-[${layoutWidth}%]`;
    } else {
      return `w-[0%]`;
    }
  }

  getSectionWidth(layoutWidth, index) {
    if (layoutWidth) {
      if (this.screenSize === 'md' || this.screenSize === 'lg' || this.screenSize === 'xl') {
        return layoutWidth == 100 ? layoutWidth : index == 0 ? layoutWidth : layoutWidth - 2
      } else {
        return 100
      }
    } else {
      return 0
    }
  }


  createComponentBasedOnType(layout: any, index: number) {
    this.createDynamicComponent(index, this.contentTypeMap[layout.contentType]);
  }

  createDynamicComponent(index: number, component) {
    let viewContainerRef: any;
    viewContainerRef = this[`${this.viewContainerRef[index]}Section`]?.viewContainerRef;
    if (viewContainerRef) {
      viewContainerRef?.clear();
      const componentRef = viewContainerRef?.createComponent(
        component
      )
      const dynamicComponentRef = <any>componentRef?.instance;
      if (dynamicComponentRef) {
        dynamicComponentRef.data = this.layouts?.[index];
      }
    }
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
    this.cdRef.detach();
  }
}
